'use client'

import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { Box, Container, Stack, Typography } from '@mui/material'
import Image from 'next/image'
import { ReactElement } from 'react'

export const MainHeroSection = (): ReactElement => {
	return (
		<Box
			id='hero-section'
			sx={{
				backgroundImage: {
					xs: 'none',
					sm: 'url(/assets/images/hero-checkout.svg)'
				},
				backgroundSize: { sm: '50vw', md: '53vw' },
				backgroundRepeat: 'no-repeat',
				backgroundPosition: {
					// xs: "bottom 10px right 10px",
					sm: 'bottom 20px right 20px'
				},
				width: '100%',
				height: '100dvh',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center'
			}}
			className='-mt-28'>
			<Container maxWidth='lg' id='main-hero-title-container' className='mt-[8vh]'>
				<Stack direction='column' alignItems='flex-start' justifyContent={'center'} spacing={15} className='w-full max-w-7xl px-4'>
					<Box width='100%' display='flex' flexDirection='column' justifyContent='left' gap={4} maxWidth={{ xs: 'none', md: '40vw', lg: '30vw' }}>
						<Typography
							variant='h2'
							align='left'
							fontWeight={700}
							className='text-left not-italic text-4xl lg:text-5xl leading-12 lg:leading-16 tracking-tight sm:tracking-[-0.02em] max-w-[950px] w-full'>
							Siapa saja bisa membuat Toko Online
						</Typography>
						<Typography
							variant='h2'
							align='left'
							fontWeight={700}
							className='text-left not-italic font-semibold text-sm md:text-md lg:text-xl leading-6 md:leading-9 text-[#263238] flex-none order-none self-stretch grow-0'>
							Buat toko online, kelola produk, kelola pesanan, atur pengiriman sampai pembayaran hanya dalam satu genggaman smartphone kamu.
						</Typography>
						<Box>
							<Box className='block xl:hidden'>
								<Box component='a' href='https://play.google.com/store/apps/details?id=com.umkmpintar.umkms' target='_blank' rel='noopener noreferrer' className='block md:hidden'>
									<Image src={'/assets/images/app-store/badge-play-store.svg'} alt={'badge-play-store'} width={180} height={0} style={{ height: 'auto' }} />
								</Box>
							</Box>
							<Box className='hidden md:block'>
								<Box className='rounded-xl p-2 md:p-4 flex flex-row gap-2 justify-between items-center bg-green-umkms w-fit h-fit'>
									<Typography variant='body2' align='left' color='white' fontWeight={600} maxWidth={130} className='text-xs md:text-sm'>
										Scan QR untuk Unduh Aplikasinya <ArrowForwardIcon />
									</Typography>
									<Image src='/assets/images/qr-code-umkms.png' alt='qr-code-umkms' width={100} height={0} style={{ height: 'auto' }} className='rounded' />
								</Box>
							</Box>
						</Box>
					</Box>
				</Stack>
			</Container>
		</Box>
	)
}
